import dayjs from "dayjs";

export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const monthsAll = [
  { text: "January", index: 0 },
  { text: "Jan", index: 0 },
  { text: "February", index: 1 },
  { text: "Feb", index: 1 },
  { text: "March", index: 2 },
  { text: "Mar", index: 2 },
  { text: "April", index: 3 },
  { text: "Apr", index: 3 },
  { text: "May", index: 4 },
  { text: "Jun", index: 5 },
  { text: "June", index: 5 },
  { text: "Jul", index: 6 },
  { text: "July", index: 6 },
  { text: "August", index: 7 },
  { text: "Aug", index: 7 },
  { text: "September", index: 8 },
  { text: "Sep", index: 8 },
  { text: "Sept", index: 8 },
  { text: "October", index: 9 },
  { text: "Oct", index: 9 },
  { text: "November", index: 10 },
  { text: "Nov", index: 10 },
  { text: "December", index: 11 },
  { text: "Dec", index: 11 },
];

export const monthsCombo = [];

monthsAll.forEach((mon) => {
  monthsAll.forEach((mont) => {
    if (mon.index - mont.index !== 0) {
      const diff = mont.index - mon.index;
      const mos = [];
      if (diff > 0) {
        for (let i = mon.index; i <= mont.index; i++) {
          mos.push(months[i]);
        }
      }

      if (diff < 0) {
        for (let i = mon.index; i <= 11; i++) {
          mos.push(months[i]);
        }

        for (let j = 0; j <= mont.index; j++) {
          mos.push(months[j]);
        }
      }

      monthsCombo.push({ text: ` ${mon.text}-${mont.text} `, months: mos });
      monthsCombo.push({ text: ` ${mon.text} to ${mont.text}`, months: mos });
    }
  });
});

export const curYear = dayjs();
export const lastYear = dayjs().subtract(1, "year");
export const nextYear = dayjs().add(1, "year");
